module.exports = __webpack_public_path__ + "img/DebatesLogo.65c3b587.png";